import React from "react";
import { Chip, Divider, Stack, Typography } from "@mui/material";
import {
  formatDisplayDate,
  formatDisplayTime,
  getActivityTypeMeta,
  getActivityCategory,
} from "../utils";

const DetailRow = ({ label, value }) => (
  <Stack spacing={0.5}>
    <Typography variant="caption" color="text.secondary" fontWeight={700}>
      {label}
    </Typography>
    <Typography variant="body2">{value || "-"}</Typography>
  </Stack>
);

const LogDetailsDialogContent = ({ log }) => {
  if (!log) return null;

  const meta = getActivityTypeMeta(log);

  return (
    <Stack spacing={2}>
      <Chip
        label={meta.shortLabel}
        size="small"
        sx={{
          width: "fit-content",
          bgcolor: meta.bg,
          color: meta.color,
          fontWeight: 700,
          border: `1px solid ${meta.color}22`,
        }}
      />

      <DetailRow label="Event Name" value={meta.label} />
      <DetailRow label="Category" value={getActivityCategory(log)} />
      <Divider />
      <DetailRow label="Details" value={log.activity_details} />
      <Divider />
      <DetailRow label="Provider" value={log.user_name} />
      <DetailRow label="User ID" value={log.user_id} />
      <DetailRow label="NPI" value={log.npi} />
      <DetailRow label="Practice ID" value={log.practice_id} />
      <DetailRow label="Date" value={formatDisplayDate(log.activity_date)} />
      <DetailRow label="Time" value={formatDisplayTime(log.activity_date)} />
      <DetailRow label="Log ID" value={log.id} />
    </Stack>
  );
};

export default LogDetailsDialogContent;
